import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";

const OceanFreight = () => {
  return (
    <>
      <Helmet>
        <title>Ocean Freight | Trans World Shipping</title>
        <meta
          name="description"
          content="Explore our comprehensive ocean freight services for all your international shipping needs."
        />
        <link
          rel="canonical"
          href="https://transworldshippingcompany.com/services/ocean-freight"
        />
      </Helmet>

      <TheOceanFreight>
        <div className="ocean-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Ocean Freight</h1>
            <p>
              One of the largest independent NVO carriers in the International
              Trade Lane
            </p>
          </div>
        </div>

        <div className="ocean-container">
          <div className="intro-section">
            <p>
              Transworld is one of the largest independent NVO carriers in the
              International Trade Lane. Founded in 1969 in Hamburg (H.Q.*) we
              have become a pacesetter in the International Trade Lane.
            </p>
          </div>

          <div className="offer-section">
            <p>
              We offer the advantages and cost efficiencies of a truly global
              organization.
            </p>
          </div>

          <div className="services-grid">
            <div className="service-item">
              Direct weekly sailings to all major ports
            </div>
            <div className="service-item">Mini- | Maxi landbridge services</div>
            <div className="service-item">
              Port terminal handling | Stevedoring
            </div>
            <div className="service-item">
              Standard | Special Container equipment
            </div>
            <div className="service-item">Food graded container</div>
            <div className="service-item">ISO Tank container | Flexi bags</div>
            <div className="service-item">Reefer | Refrigerated Container</div>
            <div className="service-item">
              Visit link for equipment specifications
            </div>
            <div className="service-item">Global intermodal system</div>
            <div className="service-item">
              Break Bulk | Slot Charter | Full Charter
            </div>
          </div>

          <div className="tech-section">
            <p>
              Our IT | IDS system is compatible with your network for secure
              data and documentation transmission.
            </p>
          </div>

          <div className="value-section">
            <p>
              Through cost leadership and transport innovation we create added
              value for our customers.
            </p>
          </div>

          <div className="challenge-section">
            <p>
              We are poised and ready to take on the challenge to carry and
              handle any unique and specific transportation requirements.
            </p>
          </div>
        </div>
      </TheOceanFreight>
    </>
  );
};

const TheOceanFreight = styled.div`
  width: 100%;
  background: #ffffff;

  .ocean-hero {
    position: relative;
    width: 100%;
    height: 40vh;
    min-height: 300px;
    background: linear-gradient(135deg, #0b1e33 0%, #0a1a2c 100%);

    .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: radial-gradient(
        circle at 30% 50%,
        rgba(212, 175, 55, 0.1) 0%,
        transparent 70%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
      width: 100%;
      padding: 0 2rem;
      z-index: 1;

      h1 {
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.2rem;
        opacity: 0.9;
      }
    }
  }

  .ocean-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 4rem 2rem;
  }

  .intro-section {
    text-align: center;
    margin-bottom: 2rem;

    p {
      font-size: 1.2rem;
      color: #0b1e33;
      line-height: 1.7;
      font-weight: 500;
    }
  }

  .offer-section {
    text-align: center;
    margin-bottom: 2.5rem;

    p {
      font-size: 1.1rem;
      color: #d4af37;
      font-weight: 600;
    }
  }

  .services-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    margin-bottom: 2.5rem;

    .service-item {
      background: #f8f9fa;
      padding: 1rem;
      border-radius: 8px;
      font-size: 0.95rem;
      color: #4a5568;
      border: 1px solid #e2e8f0;
      transition: all 0.3s ease;
      text-align: center;

      &:hover {
        border-color: #d4af37;
        transform: translateY(-2px);
      }
    }
  }

  .tech-section {
    background: #f8f9fa;
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 2rem;

    p {
      font-size: 1rem;
      color: #4a5568;
      line-height: 1.7;
    }
  }

  .value-section {
    background: linear-gradient(135deg, #0b1e33 0%, #0a1a2c 100%);
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 2rem;

    p {
      color: white;
      font-size: 1.1rem;
      line-height: 1.7;
      font-weight: 500;
    }
  }

  .challenge-section {
    text-align: center;
    padding: 2rem;

    p {
      font-size: 1.1rem;
      color: #0b1e33;
      line-height: 1.7;
      font-weight: 600;
    }
  }

  @media screen and (max-width: 900px) {
    .ocean-hero .hero-content h1 {
      font-size: 2.5rem;
    }

    .ocean-container {
      padding: 3rem 1.5rem;
    }

    .intro-section p {
      font-size: 1.1rem;
    }

    .services-grid {
      grid-template-columns: 1fr;
    }
  }

  @media screen and (max-width: 768px) {
    .ocean-hero {
      min-height: 250px;

      .hero-content h1 {
        font-size: 2rem;
      }

      .hero-content p {
        font-size: 1rem;
      }
    }

    .ocean-container {
      padding: 2rem 1rem;
    }

    .intro-section p {
      font-size: 1rem;
    }

    .offer-section p {
      font-size: 1rem;
    }

    .value-section p,
    .challenge-section p {
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 600px) {
    .ocean-hero .hero-content h1 {
      font-size: 1.6rem;
    }

    .services-grid .service-item {
      font-size: 0.85rem;
      padding: 0.75rem;
    }
  }

  @media screen and (max-width: 480px) {
    .ocean-hero .hero-content h1 {
      font-size: 1.3rem;
    }

    .ocean-hero .hero-content p {
      font-size: 0.9rem;
    }
  }
`;

export default OceanFreight;
